import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { BaseNavbarPage } from "scandoc-react-components";
import { fetchReservationGuests } from "../../requests/reservations";

function ReservationPage() {
  const navigate = useNavigate();
  const { hotelID } = useParams();
  const [searchParams] = useSearchParams();
  const reservationId = searchParams.get("ResvNameId");
  const [guests, setGuests] = useState([]);
  const [error, setError] = useState(null);

  const qsForScanBase = useMemo(() => {
    const sp = new URLSearchParams();
    if (reservationId) sp.set("ResvNameId", reservationId);
    return sp;
  }, [reservationId]);

  useEffect(() => {
    if (!hotelID || !reservationId) {
      setError("Missing hotelID or reservationId");
      return;
    }

    fetchReservationGuests({ hotelID, reservationId })
      .then((dict) => {
        // dict shape: { "guest1": data1, "guest2": data2, ... }
        const entries = Object.entries(dict || {});
        const normalized = entries.map(([guestId, data]) => ({
            guestId: guestId,
            Name: data?.Name,
            Surname: data?.Surname,
            MiddleName: data?.MiddleName
        }));
        setGuests(normalized);
        console.log(normalized)
        if (normalized.length === 0) setError("No guests found for this reservation.");
      })
      .catch((e) => setError(e?.message || "Failed to load guests"));
  }, [hotelID, reservationId]);

  useEffect(() => {
    if (error) return;
    if (!guests.length) return;

    const startIndex = 0;
    const current = guests[startIndex];

    const sp = new URLSearchParams(qsForScanBase);
    sp.set("NameId", current.guestId);
    console.log(sp)
    navigate(`/${hotelID}?${sp.toString()}`, {
      replace: true,
      state: {
        reservationMode: {
          reservationId,
          guests, // store normalized array for iteration
          index: startIndex,
        },
        expectedGuest: {
          guestId: current.guestId,
          Name: current.Name,
          Surname: current.Surname,
        },          
      },
    });
  }, [error, guests, navigate, hotelID, qsForScanBase, reservationId]);

  return (
    <BaseNavbarPage>
      {error ? (
        <div style={{ padding: 16 }}>{error}</div>
      ) : (
        <div style={{ padding: 16 }}>Loading reservation…</div>
      )}
    </BaseNavbarPage>
  );
}

export default ReservationPage;
